import { Box, Heading, Radio, RadioGroup, Stack } from '@chakra-ui/react';

export const WidgetType = ({
    selectedType,
    setSelectedType,
    selectedDataVariant,
    setSelectedDataVariant,
}: {
    selectedType?: DashboardWidgetType;
    setSelectedType: (type: DashboardWidgetType) => void;
    selectedDataVariant?: DataVariant;
    setSelectedDataVariant: (dataVariant: DataVariant) => void;
}) => {
    return (
        <Stack gap={8}>
            <Box>
                <Heading size="md" mb={2}>
                    Widget type
                </Heading>
                <RadioGroup
                    colorScheme="teal"
                    value={selectedType}
                    onChange={(value) => setSelectedType(value as DashboardWidgetType)}
                >
                    <Stack>
                        <Radio value="securityMaster">Security Master</Radio>
                        <Radio value="portfolio">Portfolio</Radio>
                        <Radio value="position">Position</Radio>
                        <Radio value="withdrawal">Withdrawal</Radio>
                    </Stack>
                </RadioGroup>
            </Box>

            {(selectedType === 'portfolio' || selectedType === 'position') && (
                <Box>
                    <Heading size="md" mb={2}>
                        Data variant
                    </Heading>
                    <RadioGroup
                        colorScheme="teal"
                        value={selectedDataVariant}
                        onChange={(value) => setSelectedDataVariant(value as DataVariant)}
                    >
                        <Stack>
                            <Radio value="report">Report</Radio>
                            <Radio value="preTrade">Pre-Trade</Radio>
                        </Stack>
                    </RadioGroup>
                </Box>
            )}
        </Stack>
    );
};
